<template>
  <div>
    <template-form :is-new="false" />
  </div>
</template>
<script>
import TemplateForm from '../components/template-form/TemplateForm.vue'

export default {
  components: {
    TemplateForm,
  },
}
</script>

 <style>

 </style>
